(function () {
  function hasTPHero(root) {
    return !!root.querySelector('img[alt^="TP:HERO"]');
  }

  function findColorFieldsets(root) {
    // Dawn uses <fieldset> for variant options. We pick the one labeled Color.
    return Array.from(root.querySelectorAll('fieldset')).filter((fs) => {
      const legend = fs.querySelector('legend');
      if (!legend) return false;
      const t = legend.textContent.trim().toLowerCase();
      return t.includes('color') || t.includes('colour'); // extend if needed
    });
  }

  function bindReclick(fieldset) {
    const radios = fieldset.querySelectorAll('input[type="radio"]');
    radios.forEach((radio) => {
      radio.addEventListener('click', () => {
        if (radio.checked) {
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[id^="MainProduct-"], .product').forEach((root) => {
      if (!hasTPHero(root)) return;
      findColorFieldsets(root).forEach(bindReclick);
    });
  });
})();
